<template>
  <div class="home x-pages-about-us kNUIZO">
    <!-- 登录后的首页 -->
    <div v-if="isLoggedIn" class="logged-in-home bFLUky">
      <SearchBar @filter-change="handleFilterChange" />
      
      <div class="products-section">
        <div class="products-container">
          <section class="dFKDPr">
            <ProductCard
              v-for="product in filteredProducts"
              :key="product.id"
              :product="product"
            />
          </section>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="totalCount > 0">
        <div class="pagination">
          <button 
            class="page-btn" 
            :disabled="page === 1"
            @click="goToPage(1)"
          >
            First
          </button>
          <button 
            class="page-btn" 
            :disabled="page === 1"
            @click="goToPage(page - 1)"
          >
            Prev
          </button>
          
          <div class="page-numbers">
            <button
              v-for="pageNum in visiblePages"
              :key="pageNum"
              class="page-btn"
              :class="{ active: pageNum === page }"
              @click="goToPage(pageNum)"
            >
              {{ pageNum }}
            </button>
          </div>
          
          <button 
            class="page-btn" 
            :disabled="page === totalPages"
            @click="goToPage(page + 1)"
          >
            Next
          </button>
          <button 
            class="page-btn" 
            :disabled="page === totalPages"
            @click="goToPage(totalPages)"
          >
            Last
          </button>
        </div>
        <div class="page-info">
          {{ totalCount }} items, Page {{ page }} / {{ totalPages }}
        </div>
      </div> 
    </div>

    <!-- 未登录的首页 -->
    <div v-else>
      <!-- Hero Section -->
      <div class="jedccR">
        <div class="dsJnVI x-container-small">
          <div class="pTGGt">
            <h1>Get cash back and discount codes for products you love!</h1>
            <p class="x-subtitle">
              <span>Get paid cash back directly to your PayPal account! No forms to mail. No checks to cash.</span>
            </p>
          </div>
          <div class="isHQGQ">
            <div class="form-group">
              <div class="">
                <input
                  type="text"
                  v-model="fullName"
                  placeholder="Full Name"
                  class="form-control"
                  autocomplete="off"
                  style="height: 49px"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="">
                <input
                  type="email"
                  v-model="email"
                  placeholder="Email"
                  class="form-control email"
                  autocomplete="off"
                  style="height: 49px"
                />
              </div>
            </div>
            <button
              type="button"
              class="btn btn-default"
              style="background-color: rgb(0, 0, 0); color: rgb(255, 255, 255); outline: none;"
              @click="handleSignup"
            >
              Get FREE Access
            </button>
            <p style="line-height: 30px; margin-top: 15px">
              By signing up, you agree to our
              <a href="#/service">Terms of Use</a>
              and
              <a href="#/policy">Privacy Policy</a>
            </p>
          </div>
        </div>
        <div class="bVLWed"></div>
      </div>

      <!-- Testimonials Section -->
      <div class="bfqpVk">
        <div class="eCveJZ">
          <span>Testimonials</span>
          <div>Don't take our word for it, see what our shoppers have to say.</div>
        </div>
        <div class="jkJcbc">
          <div v-for="testimonial in testimonials" :key="testimonial.id">
            <img :src="testimonial.image" :alt="testimonial.author" />
            <span>{{ testimonial.text }}</span>
            <span>-{{ testimonial.author }}</span>
          </div>
        </div>
        <div class="bXGNem">
          <button type="button" class="btn btn-default" @click="scrollToTop">Get Started!</button>
        </div>
        <h1 class="danQio">Discover our latest deals</h1>
        <section class="TbFIC">
          <section>
            <div class="">
              <section class="dFKDPr">
                <ProductCard
                  v-for="product in products"
                  :key="product.id"
                  :product="product"
                />
              </section>
            </div>
          </section>
        </section>
        
        <!-- Video Section -->
        <h1 class="danQio">Our shoppers love cash back!</h1>
        <div class="dHhCzD">
          <div class="fPVgrK">
            <div class="keHWGz" v-for="video in videos" :key="video.id">
              <div class="kOdbpz">
                <div>
                  <div class="jtovyt">
                    <img :src="urls+video.headimage" :alt="video.name" />
                  </div>
                  <div>
                    <div class="WqlJB">{{ video.name }}</div>
                    <div class="creAxI">
                      <img src="/static/images/about-us/checked.svg" style="width: 20px" />
                      <span class="WUytU">Verified Buyer</span>
                    </div>
                  </div>
                </div>
                <!-- 视频类型:1=视频文件,2=视频外链 -->
                <div v-if="video.type==1">
                  <div class="gnuYkV">
                    <video
                      class="x-video"
                      controls=""
                      :src="urls+video.videofile"
                    ></video>
                  </div>
                </div>
                <div v-if="video.type==2">
                  <div class="gnuYkV">
                    <iframe
                      allowfullscreen=""
                      class="x-video"
                      frameborder="0"
                      :src="video.videolink"
                      title="rebate testimony"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Why Products Discounted Section -->
        <div class="x-basics" style="margin-bottom: 0px">
          <div class="x-container hVxSwa">
            <h2>Why are these products discounted?</h2>
            <div class="x-desc" style="font-size: 18px">
              It's pretty simple, brands who are launching new products need
              sales to help them get started on Amazon. They're willing to
              lose money on those products if it means their product will
              rank better and get more sales in the long run.
            </div>
            <div class="x-process" style="margin-top: 60px">
              <img alt="How Koio deal Works" src="/static/images/about-us/processes.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <SignupModal 
      v-if="isSignupModalVisible" 
      @close="closeSignupModal"
      :prefillData="signupPrefillData"
    />
  </div>
</template>

<script>
import ProductCard from '../components/ProductCard.vue'
import SearchBar from '../components/SearchBar.vue'
import SignupModal from '../components/modals/SignupModal.vue'
import userStore from '../store/user.js'
import { productApi,commonApi } from '../api/index.js'

export default {
  name: 'Home',
  components: {
    ProductCard,
    SearchBar,
    SignupModal
  },
  data() {
    return {
      fullName: '',
      email: '',
      viewMode: 'grid',
      filters: {},
      userStore: userStore.state,
      products: [],
      loading: false,
      page: 1,
      count: 10,
      totalCount: 0,
      isSignupModalVisible: false,
      signupPrefillData: {},
      testimonials: [
        {
          id: 1,
          image: '/static/images/about-us/fb_comment_1.png',
          text: '"Awesome deal!! Got $27 off with coupon! Thanks 😊"',
          author: 'Karen Mead'
        },
        {
          id: 2,
          image: '/static/images/about-us/fb_comment_3.png',
          text: '"Thank you, I have enjoyed saving money with you all year"',
          author: 'Gloria Sorenson'
        },
        {
          id: 3,
          image: '/static/images/about-us/fb_comment_4.png',
          text: '"Awesome, love using Koio deal!"',
          author: 'James Guerin'
        }
      ],
      videos: [],
      urls:this.httpUrl
    }
  },
  computed: {
    isLoggedIn() {
      return this.userStore.isLoggedIn
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.count)
    },
    visiblePages() {
      const pages = []
      const maxVisible = 5
      let start = Math.max(1, this.page - Math.floor(maxVisible / 2))
      let end = Math.min(this.totalPages, start + maxVisible - 1)
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1)
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      
      return pages
    },
    filteredProducts() {
      let filtered = [...this.products]
      
      // 应用筛选逻辑
      if (this.filters.searchQuery) {
        filtered = filtered.filter(p => 
          p.title.toLowerCase().includes(this.filters.searchQuery.toLowerCase())
        )
      }
      
      if (this.filters.minPrice) {
        filtered = filtered.filter(p => p.currentPrice >= parseFloat(this.filters.minPrice))
      }
      
      if (this.filters.maxPrice) {
        filtered = filtered.filter(p => p.currentPrice <= parseFloat(this.filters.maxPrice))
      }
      
      if (this.filters.filterType === 'prime') {
        filtered = filtered.filter(p => p.isPrime)
      }
      
      // 排序
      if (this.filters.sortBy === 'price-low') {
        filtered.sort((a, b) => a.currentPrice - b.currentPrice)
      } else if (this.filters.sortBy === 'price-high') {
        filtered.sort((a, b) => b.currentPrice - a.currentPrice)
      }
      
      return filtered
    }
  },
  mounted() {
    // 页面加载时获取商品列表
    this.fetchProducts()
    this.getbuylog()
  },
  methods: {
    async getbuylog() {
      try {
        const response = await commonApi.getbuylog()
        
        if (response.code === 1 && response.data) {
          this.videos = response.data;
        }
      } catch (error) {
        console.error('Failed to fetch products:', error)
      } finally {
        
      }
    },
    async fetchProducts() {
      if (this.loading) return
      
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('page', this.page)
        formData.append('count', this.count)
        formData.append('order', this.filters.order || 1) // 使用筛选器中的排序方式

        const response = await productApi.getProductList(formData)
        
        if (response.code === 1 && response.data) {
          // 转换 API 数据格式为组件需要的格式
          this.products = response.data.list.map(item => ({
            id: item.id,
            title: item.title,
            image: item.image.startsWith('http') ? item.image : `https://houtai5698.koiodeal.com${item.image}`,
            currentPrice: parseFloat(item.price),
            originalPrice: parseFloat(item.originprice),
            discount: parseInt(item.discount) || Math.round((1 - parseFloat(item.price) / parseFloat(item.originprice)) * 100),
            daysLeft: item.etime,
            stock: item.stock > 0 ? `${item.stock}+` : '10+',
            isPrime: item.primeswitch === 1,
            isCollect: item.iscollect === 1,
            iscollect: item.iscollect // 保留原始字段
          }))
          this.totalCount = response.data.total_count
          
          // 同步收藏状态到 store
          if (this.isLoggedIn) {
            userStore.syncFavoritesFromProducts(this.products)
          }
        }
      } catch (error) {
        console.error('Failed to fetch products:', error)
      } finally {
        this.loading = false
      }
    },
    handleSignup() {
      // if (!this.fullName || !this.email) {
      //   this.$toast('请填写完整信息')
      //   return
      // }
      // if (!this.isValidEmail(this.email)) {
      //   this.$toast('请输入有效的邮箱地址')
      //   return
      // }
      
      // 分割姓名为 firstname 和 lastname
      const nameParts = this.fullName.trim().split(' ')
      const firstname = nameParts[0] || ''
      // const lastname = nameParts.slice(1).join(' ') || nameParts[0] || ''
      
      // 设置预填充数据
      this.signupPrefillData = {
        firstname: firstname,
        email: this.email
      }
      
      // 显示注册弹窗
      this.isSignupModalVisible = true
    },
    closeSignupModal() {
      this.isSignupModalVisible = false
      // 清空表单
      this.fullName = ''
      this.email = ''
      this.signupPrefillData = {}
    },
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.page = 1
      this.fetchProducts()
    },
    goToPage(pageNum) {
      if (pageNum < 1 || pageNum > this.totalPages || pageNum === this.page) {
        return
      }
      this.page = pageNum
      this.fetchProducts()
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.logged-in-home {
  
}

.products-section {
  padding: 20px 0;
}

.products-container {
  
}

.view-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: flex-end;
}

.view-btn {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.view-btn.active {
  background: #000;
  color: white;
  border-color: #000;
}

.view-btn svg {
  display: block;
}

.view-btn.active svg {
  stroke: white;
}

/* 分页样式 */
.pagination-wrapper {
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-btn {
  min-width: 40px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ddd;
  background: white;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.page-btn:hover:not(:disabled):not(.active) {
  background: #f5f5f5;
  border-color: #999;
}

.page-btn.active {
  background: #000;
  color: white;
  border-color: #000;
}

.page-btn:disabled {
  background: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
  border-color: #e5e5e5;
}

.page-info {
  font-size: 14px;
  color: #666;
  background: white;
  padding: 8px 16px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* 移动端适配 */
@media (max-width: 767px) {
  .pagination-wrapper {
    margin: 30px 0 80px;
  }

  .pagination {
    padding: 10px 12px;
    gap: 5px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .page-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    font-size: 13px;
  }

  .page-numbers {
    gap: 4px;
  }

  .page-info {
    font-size: 13px;
    padding: 6px 12px;
  }
}

.bFLUky {
    margin: 0px auto;
    padding: 30px 0px;
    width: 100%;
}
@media (max-width: 1366px) {
    .bFLUky {
        width: 94%;
    }
}
@media (min-width: 1367px) {
    .bFLUky {
        max-width: 1700px;
        width: 92%;
    }
}
</style>
